import { AuthState, LoginData } from "@/types/user.interfaces";

export function generateAuthData(backend: LoginData): AuthState {
  return {
    user: backend.user,
    token: backend.access_token,
    modules: backend.authorization.module,
    isAuthenticated: true,
  };
}
